<template>
  <div class="modal">
    <div class="mask"></div>
    <div :class="fit ? 'fit-content contenido-modal' : 'contenido-modal'">
      <div v-if="showMovilHeader" class="movil-header">
        <button @click="closeModal" type="button" class="btn-close"></button>
      </div>
      <div v-if="showHeader" class="modal-header">
        <span>{{ header }}</span>
        <button @click="closeModal" type="button" class="btn-close">X</button>
      </div>
      <div :class="cuerpoModal" class="cuerpo-modal">
        <div class="signature-body">
          <vueSignature
            ref="signature"
            :sigOption="option"
            width="100%"
            height="100%"
            :disabled="disabled"
            :defaultUrl="dataUrl"
          ></vueSignature>
        </div>
        <div class="button-container">
          <v-btn
            outlined
            large
            elevation="2"
            class="ml-1 my-2 my-md-0"
            @click="borrar"
          >
            Borrar
          </v-btn>
          <v-btn
            large
            color="info"
            elevation="2"
            class="ml-1 my-2 my-md-0"
            @click="guardar"
          >
            Guardar
          </v-btn>
        </div>
      </div>
      <div v-if="footer" class="modal-footer">
        <div class="modal-btn-container">
          <p @click="closeModal" class="btn-cierre">Cerrar</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSignature from "vue-signature";
export default {
  name: "FirmaDigital",
  components: {
    vueSignature,
  },
  props: {
    header: {
      type: String,
      default: "Firma digital",
    },
    showMovilHeader: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    cuerpoModal: {
      type: String,
      default: "",
    },
    footer: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["closeModal"],
  data() {
    return {
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      disabled: false,
      dataUrl: null, // "https://avatars2.githubusercontent.com/u/17644818?s=460&v=4"
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal")
    },
    borrar() {
      this.$refs.signature.clear()
    },
    async guardar() {
      const imagen = this.$refs.signature.save('image/png')
      const res = await fetch(imagen);
      const blob = await res.blob();
      const file = new File([blob], 'Firma', { type: 'image/png' });
      this.$emit('guardar', { file, imagen })
    }
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.solo {
  width: 179px;
  background-position-x: 40px;
  background-position-y: 8px;
  background-size: 18px;
}

.boton-cancelar:hover {
  color: #fff;
  background-color: #4873d3;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
}

.btn-cierre {
  font: normal normal bold 16px/22px Open Sans;
  color: #4caf50;
  padding-right: 26px;
  cursor: pointer;
}

.movil-header {
  display: none;
}

.fit-content {
  height: min-content;
  min-width: 300px;
  min-height: min-content !important;
  max-width: fit-content !important;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  padding: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.mask {
  background-color: transparent;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.contenido-modal {
  position: relative;
  background-color: #ffffff;
  margin: auto;
  border-radius: 10px;
  min-width: 320px;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  box-sizing: border-box;
  z-index: 1000;
  width: 100%;
  height: fit-content;

  max-width: 100vw;
}
.modal-header {
  border-radius: 6px 6px 0 0;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
}
.modal-header span {
  flex: 1;
  font-weight: 600;
  text-align: left;
  font: normal normal bold 18px/27px Open Sans;
  letter-spacing: 0px;
  color: #4873d3;
  opacity: 1;
  margin-top: 10px;
  text-align: center;
  font-size: 25px;
}

.btn-close {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
}

.contenido-modal .close {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
  margin-top: -10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.contenido-modal .close:hover {
  background-color: #f2f2f2;
  transition: 0.3s;
}
.contenido-modal .cuerpo-modal {
  overflow-y: auto;
  padding: 0px 25px 35px 25px;
}
.contenido-modal .cuerpo-modal.overflow {
  overflow-y: visible;
  padding: 35px;
}
.cuerpo-modal .contenedor-status {
  text-align: left;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
}
.cuerpo-modal .contenedor-item {
  width: 100%;
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font: normal normal normal 14px/19px Open Sans;
}

.signature-body {
  width: 100%;
  height: 300px;
  border: 1px solid #000;
  margin-bottom: 35px;
}
.button-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

@-webkit-keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@keyframes animatetop {
  from {
    top: -500px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}

@media (max-width: 1279px) {
  .contenido-modal {
    min-height: 400px;
    max-width: 100vw;
    border-radius: 6px;
    padding: 0;
    box-shadow: 0px 3px 6px #3d424bb2;
  }
}

@media (max-width: 767px) {
  .movil-header {
    width: 100%;
    height: 60px;
    background-color: #0a4f9c;
    position: relative;
  }

  .movil-header .btn-close {
    position: absolute;
    top: 4px;
    right: 10px;
    filter: brightness(0) invert(1);
  }
  .movil-header .btn-close:hover {
    filter: none;
    background-color: #fff;
  }
  .modal-header {
    margin-bottom: 10px;
  }

  .modal-header span {
    font: normal normal bold 14px/27px Open Sans;
  }

  .contenido-modal {
    height: min-content;
    min-height: 300px;
  }
}
</style>
